import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import React, { useMemo, useState, ReactNode } from 'react';

const SelectDropdown = ({
  options,
  value,
  placeholder,
  setValue,
  label,
  hasSearch,
  subAction,
  disabled
}: {
  options: { id: string; name: string }[];
  value: string | undefined;
  placeholder: string;
  setValue: (arg0: { id: string; name: string }) => void;
  label?: string;
  hasSearch?: boolean;
  subAction?: ReactNode;
  disabled?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState('');

  const filteredOptions = useMemo(() => {
    if (!hasSearch || !search) return options;
    return options?.filter((o) => o.name.toLowerCase().includes(search.toLowerCase()));
  }, [options, search]);

  return (
    <Dropdown
      disabled={disabled}
      visible={show}
      onClickOutside={() => setShow(false)}
      className='w-full'
      content={
        <div onClick={() => setShow(!show)}>
          <p className='my-2 font-semibold text-sm'>{label}</p>
          <div className='border-b-2 border-b-[#D5D6D7] bg-[#FAFAFA] rounded-none h-[46px] text-sm flex items-center px-4 justify-between cursor-pointer'>
            {hasSearch ? (
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className='w-full bg-transparent outline-none text-base font-medium [&:placeholder]:text-gray-4 capitalize placeholder:text-sm'
                placeholder={placeholder}
              />
            ) : (
              <p className='text-base font-medium capitalize'>
                {value ? (
                  filteredOptions?.filter((option) => option?.id === value)?.[0]?.name
                ) : (
                  <span className='text-sm text-gray-4 font-medium'>{placeholder}</span>
                )}
              </p>
            )}
            <div className='text-gray-4'>
              <ArrowDownIcon />
            </div>
          </div>
          {subAction}
        </div>
      }>
      <DropdownList>
        {filteredOptions?.map((option) => (
          <DropdownItem
            key={option?.id}
            onClick={() => {
              setValue(option);
              setSearch(option.name);
              setShow(!setShow);
            }}>
            <p className='capitalize'>{option?.name}</p>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default SelectDropdown;
